// extracted by mini-css-extract-plugin
module.exports = {"title":"TimelineComponent_title__2Pja0","flexParent":"TimelineComponent_flexParent__22iQp","timelineContainer":"TimelineComponent_timelineContainer__slrIt"};